<template>
  <div class="ratings-received-by-colleagues-tab">
    <!-- Ratings Received by Clients Table -->
    <div class="card-header py-3 px-0">
      <div class="card-title flex-column" style="justify-content: space-evenly">
        <h3 class="card-label font-weight-bolder text-dark m-0">
          Ratings Received by Clients
        </h3>
      </div>
    </div>
    <!-- Search Filter -->
    <div class="search-filter-container">
      <v-text-field
        v-model="projectSearchQuery"
        label="Search by project name"
        outlined
        dense
        prepend-inner-icon="mdi-magnify"
        class="search-input"
      ></v-text-field>
    </div>
    <div class="table-responsive mb-0">
      <table
        class="table table-head-custom table-vertical-center table-head-bg table-borderless"
      >
        <thead>
          <tr class="text-left">
            <!-- <th>Source</th>
            <th>Talent Name</th> -->
            <th>Client</th>
            <th>Squad Name</th>
            <th>Rating by</th>
            <th>Rating Submission Date</th>
            <th>Rated Month</th>
            <th>Rating</th>
            <th>Tags</th>
            <th>Review</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="talentLoading">
            <tr>
              <td colspan="8" class="text-center">Loading...</td>
            </tr>
          </template>
          <template v-else-if="!clientRatings.length">
            <tr>
              <td colspan="8" class="text-center">No ratings found.</td>
            </tr>
          </template>
          <template v-else>
            <tr
              v-for="item in paginatedClientRatings"
              :key="'client-' + item.id"
            >
              <!-- <td>
                <a :href="`/admin/squad/${item.sourceId}`" target="_blank">
                  {{ item.source }}
                </a>
              </td>
              <td>
                <a :href="`/admin/talent/${item.talentId}`" target="_blank">
                  {{ item.talentName }}
                </a>
              </td> -->
              <td>
                {{ item.client_name }}
              </td>
              <td>
                <a
                  :href="`/dashboard/client/${item?.client_id}/project/${item?.sourceId}/client-request`"
                  target="_blank"
                >
                  {{ item.source }}
                </a>
              </td>
              <td>{{ item.rated_by?.name || "N/A" }}</td>
              <td>{{ item.ratingDate }}</td>
              <td>{{ item.rated_month }}</td>
              <td>
                <v-rating
                  v-model="item.rating"
                  readonly
                  dense
                  small
                  color="primary"
                  length="5"
                  empty-icon="mdi-star"
                  full-icon="mdi-star"
                  background-color="#E0E0E0"
                ></v-rating>
              </td>
              <td>
                <v-chip
                  v-for="(tag, idx) in item.tags"
                  :key="'client-tag-' + idx"
                  color="primary"
                  class="ma-1"
                  small
                  outlined
                >
                  {{ tag }}
                </v-chip>
              </td>
              <td>
                <v-btn
                  v-if="item.score != 0"
                  depressed
                  color="primary"
                  class="mr-2"
                  @click="viewReview(item)"
                >
                  View Review
                </v-btn>
                <span v-else class="text-muted">No review</span>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <!-- Ratings Received by Talents Table -->
    <!--  <div class="card-header py-3 px-0 mt-8">
      <div class="card-title flex-column" style="justify-content: space-evenly">
        <h3 class="card-label font-weight-bolder text-dark m-0">
          Ratings Received by Talents
        </h3>
      </div>
    </div>
    <div class="table-responsive mb-0">
      <table
        class="table table-head-custom table-vertical-center table-head-bg table-borderless"
      >
        <thead>
          <tr class="text-left">
            <th>Source</th>
            <th>Talent Photo</th>
            <th>Talent Name</th>
            <th>Squad</th>
            <th>Rating Date</th>
            <th>Rating</th>
            <th>Tags</th>
            <th>Review</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in paginatedTalentRatings" :key="'talent-' + item.id">
            <td>
              <a :href="`/admin/squad/${item.sourceId}`" target="_blank">
                {{ item.source }}
              </a>
            </td>
            <td>
              <v-avatar size="36">
                <img :src="item.talentPhoto" alt="Talent Photo" />
              </v-avatar>
            </td>
            <td>
              <a :href="`/admin/talent/${item.talentId}`" target="_blank">
                {{ item.talentName }}
              </a>
            </td>
            <td>{{ item.squad }}</td>
            <td>{{ item.ratingDate }}</td>
            <td>
              <v-rating
                v-model="item.rating"
                readonly
                dense
                small
                color="amber"
                length="5"
                empty-icon="mdi-star"
                full-icon="mdi-star"
                background-color="#E0E0E0"
              ></v-rating>
            </td>
            <td>
              <v-chip
                v-for="(tag, idx) in item.tags"
                :key="'talent-tag-' + idx"
                color="primary"
                class="ma-1"
                small
                outlined
              >
                {{ tag }}
              </v-chip>
            </td>
            <td>
              <v-btn
                v-if="item.review && item.review.trim()"
                depressed
                color="primary"
                class="mr-2"
                @click="viewReview(item)"
              >
                View Review
              </v-btn>
              <span v-else class="text-muted">No review</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div> -->
    <!-- Review Modal -->
    <v-dialog v-model="reviewDialog" max-width="600px">
      <v-card>
        <v-card-title class="mb-3">Review Details</v-card-title>
        <v-card-text class="pb-0">
          <div v-if="selectedReview">
            <!-- <div class="mb-4">
              <strong>Source:</strong>
              <a
                :href="`/admin/squad/${selectedReview.sourceId}`"
                target="_blank"
              >
                {{ selectedReview.source }}
              </a>
            </div>
            <div class="mb-4">
              <strong>Talent:</strong>
              <a
                :href="`/admin/talent/${selectedReview.talentId}`"
                target="_blank"
              >
                {{ selectedReview.talentName }}
              </a>
            </div> -->
            <div class="mb-4">
              <div
                class="d-flex align-items-center flex-wrap"
                style="gap: 1rem"
              >
                <div class="d-flex align-items-center">
                  <strong class="mr-2">Client:</strong>
                  <v-chip color="primary" small outlined>
                    {{ selectedReview.client_name }}
                  </v-chip>
                </div>
                <div class="d-flex align-items-center">
                  <strong class="mr-2">Squad:</strong>
                  <v-chip color="primary" small outlined>
                    {{ selectedReview.source }}
                  </v-chip>
                </div>
              </div>
            </div>
            <div class="mb-4">
              <strong>Rating Date:</strong> {{ selectedReview.ratingDate }}
            </div>
            <div class="mb-4">
              <strong>Rating:</strong>
              <v-rating
                v-model="selectedReview.rating"
                readonly
                dense
                color="primary"
                :hover="false"
                length="5"
                show-label
                empty-icon="mdi-star"
                full-icon="mdi-star"
                background-color="#E0E0E0"
                :labels="['Worst', 'Bad', 'Neutral', 'Good', 'Excellent']"
                class="ma-2"
              ></v-rating>
            </div>
            <div class="mb-4">
              <strong>Tags:</strong>
              <v-chip
                v-for="(tag, idx) in selectedReview.tags"
                :key="'modal-tag-' + idx"
                color="primary"
                class="ma-1"
                small
                outlined
              >
                {{ tag }}
              </v-chip>
            </div>
            <div>
              <strong>Review:</strong>
              <p :class="{ 'text-muted': !selectedReview.review }">
                {{ selectedReview.review || "No review" }}
              </p>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="reviewDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { format } from "date-fns";
import debounce from "lodash/debounce";
export default {
  name: "RatingsReceivedByColleaguesTab",
  props: {
    talentId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      reviewDialog: false,
      selectedReview: null,
      // Ratings Received by Clients (will be filled from API)
      clientRatings: [],
      // Dummy data for Ratings Received by Talents
      talentRatings: [
        {
          id: 1,
          source: "Squad 1",
          sourceId: 401,
          talentPhoto: "https://randomuser.me/api/portraits/men/45.jpg",
          talentName: "Mike Johnson",
          talentId: 103,
          squad: "Squad 1",
          ratingDate: "2024-03-10",
          rating: 5,
          tags: ["Excellent Quality", "Proactive"],
          review: "Outstanding quality and very proactive in solving issues.",
        },
        {
          id: 2,
          source: "Squad 2",
          sourceId: 402,
          talentPhoto: "https://randomuser.me/api/portraits/women/36.jpg",
          talentName: "Emily Clark",
          talentId: 104,
          squad: "Squad 2",
          ratingDate: "2024-03-08",
          rating: 4,
          tags: ["Team Player", "Helpful"],
          review: "Great team player and always willing to help.",
        },
      ],
      talentLoading: false,
      projectSearchQuery: "",
    };
  },
  computed: {
    paginatedClientRatings() {
      return this.clientRatings;
    },
    paginatedTalentRatings() {
      return this.talentRatings;
    },
  },
  watch: {
    projectSearchQuery(newValue) {
      const trimmedValue = newValue ? newValue.trim() : "";
      if ((trimmedValue && trimmedValue.length > 1) || newValue === "") {
        this.debouncedSearchRatings();
      }
    },
  },
  mounted() {
    // Create debounced search function (500ms delay)
    this.debouncedSearchRatings = debounce(() => {
      this.fetchRatings();
    }, 500);

    this.fetchData();
  },
  methods: {
    ...mapActions({
      getTalentRatings: "talents/getTalentRatings",
    }),
    viewReview(item) {
      console.log(item);
      this.selectedReview = item;
      this.reviewDialog = true;
    },
    async fetchRatings() {
      this.talentLoading = true;

      const params = {
        type: "client_rate_talent",
        ratable_id: this.$route.params.id,
      };

      // Only add project_name if search query is not empty/falsy
      if (this.projectSearchQuery && this.projectSearchQuery.trim()) {
        params.project_name = this.projectSearchQuery.trim();
      }

      this.getTalentRatings(params)
        .then((res) => {
          // Map API data to table format
          this.clientRatings = (res.data || []).map((item) => ({
            id: item.id,
            source:
              item.client_project?.project_name ||
              item.client_project?.internal_name ||
              "",
            sourceId: item.client_project?.id || "",
            talentName: item.ratable?.talent_name || "",
            talentId: item.ratable?.id || "",
            client: item.client_project?.project_name || "",
            ratingDate: item.rated_at ? item.rated_at.split(" ")[0] : "",
            rating: item.score,
            tags: [
              ...(item.rating_options?.positive?.map((opt) => opt.label) || []),
              ...(item.rating_options?.negative?.map((opt) => opt.label) || []),
            ],
            review: item.review,
            rated_by: item.rated_by,
            rated_month: item.created_at
              ? format(new Date(item.created_at), "MMMM yyyy")
              : "",
            client_id: item?.rater?.id,
            client_name: item?.rater?.client_name || "",
          }));
        })
        .catch(() => {
          this.clientRatings = [];
        })
        .finally(() => {
          this.talentLoading = false;
        });
    },
    async fetchData() {
      // Fetch ratings (will use current search query if any)
      this.fetchRatings();
    },
  },
};
</script>
<style scoped>
.ratings-received-by-colleagues-tab {
  padding: 1rem;
}
.table-responsive {
  margin-bottom: 0;
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #181c32;
  border-collapse: collapse;
}
.table th {
  font-weight: 500;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 0.1rem;
  padding: 0.75rem 1rem;
  background-color: #f3f6f9;
  border-bottom: 1px solid #ebedf3;
}
.table td {
  padding: 0.75rem 1rem;
  vertical-align: middle;
  border-bottom: 1px solid #ebedf3;
}
.table-borderless td,
.table-borderless th {
  border: 0;
}
.table-head-bg th {
  background-color: #f3f6f9;
}
.table-vertical-center td {
  vertical-align: middle;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: wrap;
  min-height: 70px;
  padding: 0 2.25rem;
  background-color: transparent;
  border-bottom: 1px solid #ebedf3;
}
.card-title {
  display: flex;
  margin: 0.5rem;
  margin-left: 0;
  flex-wrap: wrap;
  align-items: center;
}
.card-label {
  display: flex;
  align-items: center;
  margin: 0;
  margin-left: 0.75rem;
  margin-right: 0.5rem;
  font-weight: 500;
  color: #181c32;
  font-size: 1.275rem;
}
.text-center {
  text-align: center;
}
.text-muted {
  color: #6c757d;
  font-style: italic;
}

.search-filter-container {
  max-width: 400px;
  margin-top: 2rem;
}

.search-input {
  margin-bottom: 0;
}
</style>
